/**
 * ============================================================================
 * useAuditsQuery — Phase 7 frontend
 * Owner: Phase 7 — Internal Audit Programme Module.
 * Purpose: TanStack Query hook for the audit list (year-filtered).
 * Endpoint: GET /api/v1/audits?year=YYYY
 * URS rows: INA-001, INA-003.
 * ============================================================================ */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';
import type { AuditListItem, AuditStatus, PageResponse } from './types';

export interface AuditsQueryInput {
  year: number;
  status?: AuditStatus;
}

export function useAuditsQuery(
  input: AuditsQueryInput,
): UseQueryResult<PageResponse<AuditListItem>, Error> {
  return useQuery<PageResponse<AuditListItem>, Error>({
    queryKey: ['internal-audit', 'audits', input.year, input.status ?? null],
    queryFn: () => {
      const params = new URLSearchParams();
      params.set('year', String(input.year));
      if (input.status) params.set('status', input.status);
      return apiFetch<PageResponse<AuditListItem>>(
        `/api/v1/audits?${params.toString()}`,
      );
    },
    staleTime: 30_000,
  });
}
